export default "__VITE_ASSET__DNmj4wzf__"